import './CheckboxGroup.css'
import cx from 'classnames'
import { Checkbox } from '../Checkbox/Checkbox'
import { Label } from '../InputLabel/InputLabel'

export function CheckboxGroup({
  id,
  checked,
  className,
  label,
  onChange,
  disabled
}: {
  id: string
  checked: boolean
  className?: string
  label: React.ReactNode
  onChange: (checked: boolean) => void
  disabled?: boolean
}) {
  return (
    <div className={cx('checkbox-group-container', className)}>
      <Checkbox id={id} checked={checked} onChange={onChange} disabled={disabled} />
      <Label
        htmlFor={id}
        className={cx('checkbox-group-label', { 'checkbox-group-label-disabled': disabled })}
      >
        {label}
      </Label>
    </div>
  )
}
